import { get } from 'api';

export const getProjectsList = (owner: string) =>
  get({
    url: `/${owner}/projects`,
  });
